<script lang="ts">
	import { getStructuredDataScript } from "@utils/getStructuredDataScript.js";
	import type { Breadcrumb } from "@core/schema/Breadcrumb.js";

	const {
		breadcrumbs,
		title,
		canonical,
		webUrl,
	}: {
		breadcrumbs: Breadcrumb[];
		title: string;
		canonical: string;
		webUrl: string;
	} = $props();

	const items = [
		{ name: "Domů", item: webUrl },
		...breadcrumbs.map(({ label, href }) => ({ name: label, item: `${webUrl}${href}` })),
		{ name: title, item: canonical },
	];

	const script = getStructuredDataScript({
		"@context": "https://schema.org" as const,
		"@type": "BreadcrumbList" as const,
		itemListElement: items.map(({ name, item }, index) => ({
			"@type": "ListItem" as const,
			position: index + 1,
			name,
			item,
		})),
	});

	/* eslint-disable svelte/no-at-html-tags */
</script>

<svelte:head>
	{@html script}
</svelte:head>
